import { TypeOf } from "./types";
import { interceptCustomElement, InterceptCustomElementCallback } from "./custom-elements";
import { CSSResultGroup, LitElement } from "@umbraco-cms/backoffice/external/lit";

type LitElementExtended<T extends LitElement> = TypeOf<T> & {
    // Static
    styles?: CSSResultGroup;

    // Instance
    prototype: T & {
        firstUpdated: () => unknown;
        render: () => unknown;
    };
};

export function interceptLitElement<T extends LitElement = LitElement>(
    name: string,
    callback: InterceptCustomElementCallback<T & LitElementExtended<T>["prototype"]>
): void {
    interceptCustomElement(name, callback);
}

export function appendStyles<T extends LitElement>(
    constructor: LitElementExtended<T>,
    styles: CSSResultGroup
): void {
    constructor.styles = [
        ...toArray(constructor.styles),
        ...toArray(styles),
    ];
}

function toArray(value: CSSResultGroup | undefined): CSSResultGroup[] {
    if (value === undefined) {
        return [];
    }

    if (Array.isArray(value)) {
        return value;
    }

    return [value];
}
